const Section = ({ title, links }) => (
    <div className='footer-section'>
        <h2 className="text-xs font-bold lg:text-base mb-2">{title}</h2>
        <ul className="text-xs space-y-2">
            {links.map((link, index) => (
                <li key={index}>
                    {typeof link.text === 'string' ? (
                        <a className="hover:shadow-sm hover:font-bold" href={link.href} download={link.download || false}>{link.text}</a>
                    ) : (
                        link.text
                    )}
                </li>
            ))}
        </ul>
    </div>
);

export default Section;
